var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex justify-content-center align-items-center",staticStyle:{"height":"100vh","display":"none"},attrs:{"id":"loader"}},[_c('GeneralLoading')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }